import React from "react";
import { PenTool, Megaphone, Search } from "lucide-react";

const SSMProductSection = () => {
  return (
    <section className="py-16 lg:py-20 relative overflow-hidden bg-gradient-to-br from-[#0b0f19] via-[#131a2e] to-[#070a12] text-white">
      {/* Background glows */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-10 w-72 h-72 bg-red-500/15 blur-3xl" />
        <div className="absolute top-10 right-0 w-72 h-72 bg-amber-400/10 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 w-80 h-80 bg-purple-500/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* LEFT: copy */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-5">
              <span className="inline-block w-2 h-2 rounded-full bg-amber-400" />
              <span className="text-xs sm:text-sm font-semibold text-white/90 tracking-wider">
                SSM PRODUCT
              </span>
              <span className="text-xs font-semibold text-amber-200/90">• Launching 2026</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
              One AI Tool for SEO, Blogs &amp; Social Media —
              <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-red-400 to-pink-400">
                Meet Orator SSM
              </span>
            </h2>

            <p className="mt-4 text-gray-300 text-base sm:text-lg leading-relaxed max-w-xl">
              Automate your entire content strategy with AI. Write, schedule, rank — all in one place.
            </p>

            {/* Features */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[{
                Icon: PenTool,
                title: "AI Blog Writing",
                desc: "Generate SEO-ready blogs in minutes.",
              }, {
                Icon: Megaphone,
                title: "AI Social Media Posts",
                desc: "Create posts that fit your brand voice.",
              }, {
                Icon: Search,
                title: "AI SEO Optimization",
                desc: "Improve rankings with smart recommendations.",
              }].map(({ Icon, title, desc }) => (
                <div
                  key={title}
                  className="group rounded-2xl bg-white/5 border border-white/10 p-5 hover:bg-white/10 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-300/20 to-red-500/20 border border-amber-300/20 flex items-center justify-center mb-4 group-hover:shadow-[0_0_28px_rgba(245,158,11,0.25)] transition-all">
                    <Icon className="w-6 h-6 text-amber-200" />
                  </div>
                  <h3 className="font-bold text-white/95 text-base">{title}</h3>
                  <p className="mt-1 text-sm text-gray-300 leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://ssm.oratorhype.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 bg-gradient-to-r from-sky-500 to-blue-500 text-white font-extrabold shadow-xl shadow-red-500/20 hover:shadow-red-500/35 transition-all"
              >
                Try SSM Free <span className="text-xl">→</span>
              </a>
              <div className="text-sm text-white/70">
                Used by <span className="text-amber-200 font-semibold">500+</span> businesses
              </div>
            </div>
          </div>

          {/* RIGHT: mockup */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-red-500/20 via-amber-400/10 to-purple-500/10 blur-2xl rounded-[2.25rem]" />
            <div className="relative rounded-[2.25rem] overflow-hidden border border-white/10 bg-white/5 shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/35" />
              <img
                src="/assets/WB_PAGE.png"
                alt="Orator SSM product mockup"
                className="relative w-full h-[360px] sm:h-[420px] object-contain p-8"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SSMProductSection;

